/**
 * 系统配置常量
 * 定义所有可配置的系统参数
 */
/**
 * 配置分类
 */
export const ConfigCategories = {
    GENERAL: 'general',
    CURRENCY: 'currency',
    NOTIFICATION: 'notification',
    SECURITY: 'security',
};
/**
 * 配置值类型
 */
export const ConfigTypes = {
    STRING: 'string',
    NUMBER: 'number',
    BOOLEAN: 'boolean',
    ENUM: 'enum',
};
/**
 * 支持的货币列表
 */
export const SupportedCurrencies = ['USDT', 'AED', 'USD', 'CNY', 'EUR'];
/**
 * 通知类型
 */
export const NotificationTypes = {
    APPROVAL_REQUEST: 'approval_request',
    APPROVAL_RESULT: 'approval_result',
    TASK_ASSIGNMENT: 'task_assignment',
    TASK_MENTION: 'task_mention',
    SYSTEM_ANNOUNCEMENT: 'system_announcement',
    STAGE_HANDOFF: 'stage_handoff',
};
/**
 * 通知渠道
 */
export const NotificationChannels = {
    EMAIL: 'email',
    IN_APP: 'inApp',
    SLACK: 'slack',
};
/**
 * 预定义的系统配置项
 */
export const CONFIG_DEFINITIONS = [
    // 通知配置
    {
        key: 'notification.email.enabled',
        name: '邮件通知',
        description: '是否启用邮件通知渠道',
        category: ConfigCategories.NOTIFICATION,
        type: ConfigTypes.BOOLEAN,
        defaultValue: true,
    },
    {
        key: 'notification.inApp.enabled',
        name: '站内通知',
        description: '是否启用站内通知渠道',
        category: ConfigCategories.NOTIFICATION,
        type: ConfigTypes.BOOLEAN,
        defaultValue: true,
    },
    {
        key: 'notification.slack.enabled',
        name: 'Slack 通知',
        description: '是否启用 Slack 通知渠道',
        category: ConfigCategories.NOTIFICATION,
        type: ConfigTypes.BOOLEAN,
        defaultValue: true,
    },
    // 通知触发器配置
    {
        key: 'notification.trigger.approval_request',
        name: '审批请求通知',
        description: '是否在收到审批请求时发送通知',
        category: ConfigCategories.NOTIFICATION,
        type: ConfigTypes.BOOLEAN,
        defaultValue: true,
    },
    {
        key: 'notification.trigger.approval_result',
        name: '审批结果通知',
        description: '是否在审批完成时发送通知',
        category: ConfigCategories.NOTIFICATION,
        type: ConfigTypes.BOOLEAN,
        defaultValue: true,
    },
    {
        key: 'notification.trigger.task_assignment',
        name: '任务分配通知',
        description: '是否在任务分配时发送通知',
        category: ConfigCategories.NOTIFICATION,
        type: ConfigTypes.BOOLEAN,
        defaultValue: true,
    },
    {
        key: 'notification.trigger.task_mention',
        name: '任务提及通知',
        description: '是否在被@提及时发送通知',
        category: ConfigCategories.NOTIFICATION,
        type: ConfigTypes.BOOLEAN,
        defaultValue: true,
    },
    {
        key: 'notification.trigger.system_announcement',
        name: '系统公告通知',
        description: '是否发送系统公告通知',
        category: ConfigCategories.NOTIFICATION,
        type: ConfigTypes.BOOLEAN,
        defaultValue: true,
    },
];
/**
 * 配置键常量
 */
export const ConfigKeys = {
    NOTIFICATION_EMAIL_ENABLED: 'notification.email.enabled',
    NOTIFICATION_IN_APP_ENABLED: 'notification.inApp.enabled',
    NOTIFICATION_SLACK_ENABLED: 'notification.slack.enabled',
    NOTIFICATION_TRIGGER_APPROVAL_REQUEST: 'notification.trigger.approval_request',
    NOTIFICATION_TRIGGER_APPROVAL_RESULT: 'notification.trigger.approval_result',
    NOTIFICATION_TRIGGER_TASK_ASSIGNMENT: 'notification.trigger.task_assignment',
    NOTIFICATION_TRIGGER_TASK_MENTION: 'notification.trigger.task_mention',
    NOTIFICATION_TRIGGER_SYSTEM_ANNOUNCEMENT: 'notification.trigger.system_announcement',
};
/**
 * 默认用户通知偏好
 */
export const DEFAULT_USER_NOTIFICATION_PREFERENCES = {
    [NotificationTypes.APPROVAL_REQUEST]: { email: true, inApp: true, slack: true },
    [NotificationTypes.APPROVAL_RESULT]: { email: true, inApp: true, slack: true },
    [NotificationTypes.TASK_ASSIGNMENT]: { email: false, inApp: true, slack: true },
    [NotificationTypes.TASK_MENTION]: { email: false, inApp: true, slack: true },
    [NotificationTypes.SYSTEM_ANNOUNCEMENT]: { email: true, inApp: true, slack: false },
    [NotificationTypes.STAGE_HANDOFF]: { email: false, inApp: true, slack: true },
};
/**
 * 获取配置定义
 */
export function getConfigDefinition(key) {
    return CONFIG_DEFINITIONS.find((def) => def.key === key);
}
/**
 * 获取分类下的所有配置
 */
export function getConfigsByCategory(category) {
    return CONFIG_DEFINITIONS.filter((def) => def.category === category);
}
//# sourceMappingURL=system-config.js.map